import {NormalizerI} from './normalizer.i';
import {isString} from 'lodash';

const DATE_CONST = {
    dot: '.',
    empty: '',
    symbolsCount: 13
};

export class DateNormalizer implements NormalizerI {

    normalize(value: string): string {

        if (!isString(value)) {
            return '';
        }

        value = value.replace(/[^0-9]/g, DATE_CONST.empty);
        if (value.length >= 8) {
            value = value.substring(0, 2) + DATE_CONST.dot + value.substring(2, 4) + DATE_CONST.dot + value.substring(4, 8);
        } else if (value.length <= 7 && value.length >= 5) {
            value = value.substring(0, 2) + DATE_CONST.dot + value.substring(2, 4) + DATE_CONST.dot + value.substring(4, value.length);
        } else if (value.length <= 4 && value.length >= 3) {
            value = value.substring(0, 2) + DATE_CONST.dot + value.substring(2, value.length);
        }
        return value;
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/normalizers/date.normalizer.ts